import axiosIns from '@/plugins/axios'

export default {
  getToday() {
    return axiosIns.get('/admin/cast_app/punch_tokens/today')
  },
}
